import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import get from 'lodash/get';
import assign from 'lodash/assign';
import chunk from 'lodash/chunk';
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';
import striptags from 'striptags';
import Card from '../card/card';
import Ad from '../ad/ad';
import Slug from '../slug/slug';
import FCLink from '../fc_link/fc_link';
import matchMediaDesktop from '../../../utils/client_util';
import { imageSizesLookup } from '../../../utils/cloudinary_asset_util';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';
import { getBrandworksName } from '../advertorial/advertorial';

function noop() {}

class AllFeed extends Component {
  constructor(props) {
    super(props);
    this.renderMoreButton = this.renderMoreButton.bind(this);
    this.enableInfiniteScroll = this.enableInfiniteScroll.bind(this);
    this.handleScroll = debounce(this.handleScroll.bind(this), 100);
  }

  componentDidMount() {
    this.isDesktop = matchMediaDesktop();
  }

  componentWillUnmount() {
    this.removeEvents();
  }

  getAllStories() {
    const formattedStories = this.props.stories.map((post, i) =>
      assign(post, {
        site: 'Fast Company',
        assetSizes:
          i === 0 ? imageSizesLookup.bigFirstMobile : imageSizesLookup[3],
        allowNoImage: true,
        excerpt: striptags(post.excerpt || '')
      })
    );

    if (
      this.props.allRendered ||
      this.props.paginationEnabled ||
      this.props.infiniteScrollEnabled
    ) {
      return formattedStories;
    }

    return get(this.props, 'stories.length') >= 10
      ? formattedStories.slice(0, 10)
      : formattedStories;
  }

  getSections() {
    const sections = chunk(this.getAllStories(), 10);

    return sections.map((section, index) => ({
      id: `section-${index + 1}`,
      stories: section
    }));
  }

  removeEvents() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  enableInfiniteScroll(e) {
    e.preventDefault();
    this.infiniteScrollInitialized = true;
    this.props.hideRecircFeed();
    this.props
      .infiniteScrollAllFeedFetch(
        {
          page: this.props.page + 1,
          slug: this.props.section
        },
        this.props.config
      )
      .then(() => {
        window.addEventListener('scroll', this.handleScroll);
      });
  }

  handleScroll() {
    if (!this.props.infiniteScrollLoading) {
      if (this.props.totalPages < this.props.page) {
        return this.removeEvents();
      }
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 3000
      ) {
        return this.props.infiniteScrollAllFeedFetch(
          {
            page: this.props.page + 1,
            slug: this.props.section
          },
          this.props.config
        );
      }
    }
    return false;
  }

  renderMoreButton(index, allFeedLength, isLastSection, isLastPage, config) {
    if (this.props.infiniteScrollEnabled) {
      if (this.infiniteScrollInitialized) {
        return null;
      }

      if (
        this.props.totalPages === 1 ||
        (this.props.infiniteScrollLoading && !isLastSection)
      ) {
        return null;
      }

      if (isLastSection) {
        const page = this.props.page + 1;
        let href =
          this.props.type === 'homepage'
            ? `/all/${page}`
            : `/${this.props.type}/${this.props.section}/${page}`;

        if (this.props.hrefOverride) {
          href = `${this.props.hrefOverride}${page}`;
        }
        return (
          <a
            title={`See More ${this.props.section} on page ${this.props.page}`}
            href={href}
            className="all-feed__more"
          >
            <button onClick={this.enableInfiniteScroll}>
              See More Stories
            </button>
          </a>
        );
      }
    }

    if (this.props.paginationEnabled) {
      if (isLastPage) {
        return null;
      }
      if (isLastSection) {
        const { page } = this.props;
        let href =
          this.props.type === 'homepage'
            ? `/all/${page}`
            : `/${this.props.type}/${this.props.section}/${page}`;

        if (this.props.hrefOverride) {
          href = `${this.props.hrefOverride}${page}`;
        }
        if (href === '/section//2') {
          href = '/section/innovation-by-design-2019/2';
        }
        return (
          <div
            className={`all-feed__button all-feed__button--${get(
              config,
              'site',
              ''
            )} ${
              this.props.mobileSeeMoreHidden
                ? 'all-feed__button--mobile-hidden'
                : ''
            }`}
          >
            <FCLink
              title={`See More ${this.props.section} on page ${this.props.page +
                1}`}
              to={href}
              config={config}
            >
              <button>See More Stories</button>
            </FCLink>
          </div>
        );
      }
      return null;
    }

    if (index !== 1 || this.props.allRendered || this.props.disableMore) {
      return null;
    }

    return (
      <div
        className={`all-feed__button all-feed__button--${get(
          config,
          'site',
          ''
        )} ${
          this.props.mobileSeeMoreHidden
            ? 'all-feed__button--mobile-hidden'
            : ''
        }`}
      >
        <button onClick={this.props.setAllLoadedState}>See More Stories</button>
      </div>
    );
  }

  renderMobileAd(index) {
    if (index === 1) {
      return null;
    }
    // WARNING: This is a hack. mobilerectangle needs to be suffixed with
    // a dynamic count on the index page. we pass an array of suffixes that
    // reflect that count that mirrors the index in this scope. So since we
    // we return null for index of 1, we provide an array as an argument that
    // looks like [4, null, 5]. If not argument is provided, we just render
    // mobilerectangle with no suffix`
    const adCount = this.props.mobileAdCount[index];
    const adSuffix = adCount ? `_${adCount}` : '';
    return (
      <div className="all-feed__mobile-ad-container">
        <Ad {...this.props.adModel} name={`mobilerectangle${adSuffix}`} />
      </div>
    );
  }

  renderSlugOrName(props) {
    if (!props || !props.hasSlug) {
      return null;
    }

    if (props.authorPage) {
      if (isEmpty(props.author)) return '';

      return (
        <h2 className="author-page__all-feed-title">
          {`Stories by ${get(props.author, 'name')}`}
          <span className="author-page__all-feed-title-rss">
            <a href={`/user/${get(props.author, 'slug')}/rss`}>RSS</a>
          </span>
        </h2>
      );
    }

    if (!isEmpty(props.advertorialSlugs)) {
      const advertorialName = get(props.advertorialSlugs, 'name');
      const companyName = getBrandworksName([{ name: advertorialName }]);

      return (
        <Slug
          slugName={
            get(props, 'allStoriesTitle')
              ? `ALL ${companyName} STORIES`
              : get(props.advertorialSlugs, 'name')
          }
          className="tag-page"
          advertorial={true}
        />
      );
    }

    let archives = {};
    if (props.titleOverride.indexOf('Magazine') > -1) {
      archives = {
        name: 'See Archives',
        url: '/magazine/archive'
      };
    }

    return (
      <Slug
        linkTo="//www.fastcompany.com"
        slugName={get(props, 'titleOverride') || 'All Stories'}
        archives={archives}
      />
    );
  }

  render() {
    const {
      config,
      advertorialSlugs,
      authorPage,
      author,
      hasSlug,
      titleOverride,
      isLastPage,
      type,
      allStoriesTitle,
      brandworksSlug,
      featuredTop
    } = this.props;
    let { modifier } = this.props;

    if (!modifier && !hasSlug) {
      modifier = 'no-slug';
    }

    const fullPageAdvertorial = modifier === 'advertorial';

    const allFeedLength = get(this.props, 'stories.length', 0);

    let allFeedClassName = `all-feed__wrapper ${
      modifier ? `all-feed__wrapper--${modifier}` : ''
    }`;

    if (type === 'user') {
      allFeedClassName += ` all-feed__wrapper--${type}`;
    }
    return (
      <section className="all-feed">
        {this.renderSlugOrName({
          advertorialSlugs,
          authorPage,
          author,
          hasSlug,
          titleOverride,
          allStoriesTitle
        })}

        <div className={allFeedClassName}>
          {this.getSections().map((section, sectionIndex) => {
            const isLastSection =
              this.getSections().length === sectionIndex + 1;
            const adCounter = sectionIndex + 1 > 10 ? 10 : sectionIndex + 1;

            return (
              <div key={section.id} className="all-feed__section">
                <div className="all-feed__posts">
                  {section.stories.map((story, cardIndex) => {
                    if (brandworksSlug) {
                      // eslint-disable-next-line no-param-reassign
                      story.customEyebrowText = brandworksSlug;
                      // eslint-disable-next-line no-param-reassign
                      story.fullyReplaceEyebrow = true;
                    }
                    return (
                      <Card
                        type="all-feed"
                        key={story.id || story.mediaid}
                        metadata={story}
                        config={config}
                        hasExcerpt={story.layout === 'long'}
                        fullPageAdvertorial={fullPageAdvertorial}
                        top={
                          featuredTop && sectionIndex === 0 && cardIndex === 0
                        }
                        cardEvent={() => {
                          trackGAEvent({
                            eventCategory: 'Engagement',
                            eventAction: `AllFeed:Pos-${cardIndex + 1}`,
                            eventLabel: get(story, 'link')
                          });
                        }}
                      />
                    );
                  })}
                  {this.renderMobileAd(sectionIndex)}
                  {this.renderMoreButton(
                    sectionIndex,
                    allFeedLength,
                    isLastSection,
                    isLastPage,
                    config
                  )}
                </div>

                <div className="all-feed__sidebar">
                  <div
                    className="all-feed__promotion"
                    id={`sidebar-ad-${sectionIndex}`}
                  >
                    <Sticky
                      top={100}
                      bottomBoundary={`#sidebar-ad-${sectionIndex}`}
                      enabled={this.isDesktop}
                    >
                      <Ad
                        {...this.props.adModel}
                        name={`flexiblehalfpage_${adCounter}`}
                      />
                    </Sticky>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}

AllFeed.defaultProps = {
  stories: [],
  allRendered: false,
  modifier: '',
  mobileSeeMoreHidden: false,
  advertorialSlugs: {},
  authorPage: false,
  author: {},
  hasSlug: true,
  disableMore: false,
  titleOverride: '',
  paginationEnabled: false,
  totalPages: 0,
  page: 0,
  section: '',
  type: '',
  isLastPage: false,
  infiniteScrollEnabled: false,
  infiniteScrollAllFeedFetch: noop,
  hideRecircFeed: noop,
  setAllLoadedState: noop,
  infiniteScrollLoading: false,
  hrefOverride: '',
  mobileAdCount: [],
  allStoriesTitle: false,
  brandworksSlug: '',
  featuredTop: true
};

AllFeed.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.shape({})),
  adModel: PropTypes.shape({}).isRequired,
  allRendered: PropTypes.bool,
  setAllLoadedState: PropTypes.func,
  modifier: PropTypes.string,
  mobileSeeMoreHidden: PropTypes.bool,
  advertorialSlugs: PropTypes.shape({}),
  authorPage: PropTypes.bool,
  author: PropTypes.shape({}),
  hasSlug: PropTypes.bool,
  disableMore: PropTypes.bool,
  titleOverride: PropTypes.string,
  paginationEnabled: PropTypes.bool,
  type: PropTypes.string,
  section: PropTypes.string,
  page: PropTypes.number,
  totalPages: PropTypes.number,
  isLastPage: PropTypes.bool,
  infiniteScrollLoading: PropTypes.bool,
  infiniteScrollEnabled: PropTypes.bool,
  infiniteScrollAllFeedFetch: PropTypes.func,
  hideRecircFeed: PropTypes.func,
  config: PropTypes.shape({}).isRequired,
  hrefOverride: PropTypes.string,
  mobileAdCount: PropTypes.arrayOf(PropTypes.number),
  allStoriesTitle: PropTypes.bool,
  brandworksSlug: PropTypes.string,
  featuredTop: PropTypes.bool
};

export default AllFeed;
